import React, { useState } from 'react'
import {
    Container, Row, Col, Modal, ModalBody, ModalFooter, Button
} from 'reactstrap'
import { Link, withRouter, useLocation } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import ImageGallery from 'react-image-gallery'
import Menu from '../../assets/images/vendora-bienvenida-menu.png'
import Perfil from '../../assets/images/vendora-bienvenida-perfil.png'
import iconstep01 from '../../assets/images/welcomeicons-01.png'
import iconstep02 from '../../assets/images/welcomeicons-02.png'
import iconstep03 from '../../assets/images/welcomeicons-03.png'
import iconstep04 from '../../assets/images/welcomeicons-04.png'
import iconstep05 from '../../assets/images/welcomeicons-05.png'
import "react-image-gallery/styles/scss/image-gallery.scss"
import '../../assets/css/app.css'

const Welcome = (props) => {
    const location = useLocation();

    const [openWelcomeModal, setOpenWelcomeModal] = useState(false)

    const toggleOpenWelcomeModal = () => setOpenWelcomeModal(!openWelcomeModal)

    React.useEffect(() => {
        if (location.search === '?modal=1') {
            toggleOpenWelcomeModal()
        }
    }, [location]); // eslint-disable-line

    const images = [
        {
          original: 'https://storage.googleapis.com/vendora-storage/assets/images/onboarding_vendora15-1.png',
          bulletClass: 'gallery-bullets'
        },
        {
          original: 'https://storage.googleapis.com/vendora-storage/assets/images/onboarding_vendora15-2.png',
          bulletClass: 'gallery-bullets'
        },
        {
          original: 'https://storage.googleapis.com/vendora-storage/assets/images/onboarding_vendora15-3.png',
          bulletClass: 'gallery-bullets'
        },
    ]

    return (
        <React.Fragment>
            <div className="page-content welcome">
                <Container fluid style={{ maxWidth: !isMobile ? '700px' : '100%' }}>
                    {isMobile && (
                        <Row style={{ marginBottom: '20px' }}>
                            <Col xs={6} sm={6} lg={6}>
                                 <img alt="Flecha al Menú" width={100} src={Menu} />
                            </Col>
                            <Col xs={6} sm={6} lg={6} style={{ textAlign: 'right' }}>
                                <img alt="Flecha al Perfil" width={145} src={Perfil} />
                            </Col>
                        </Row>
                    )}

                    <div>
                        <div><h1 className="welcomesectiontitle">¡Bienvenida a <span className="welcomesectionhigh">Vendora!</span></h1></div>
                        <br></br>
                        <p className="welcomedescription">Vendora es la plataforma de reventa digital para iniciar tu negocio sin inversión inicial ni membresias.</p>
                        
                        <div className="video-embed-container">
                            <iframe
                                src='https://www.youtube.com/embed/ftZlYJQG5co?rel=0'
                                title="WelcomeFrame"
                                frameBorder='0'
                                allowFullScreen
                            ></iframe>
                        </div>
                        <br></br>

                        <p className="welcomesteps">¡Empieza a generar ingresos en <span className="stepshighlight">5 pasos!</span></p>
                        
                        <br /><br />
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Paso 1: Comparte"  src={iconstep01} /></div>
                            <div>
                                <h2 className="stepvendora">PASO 1</h2>
                                <p className="stepvendoratitle">Comparte tus catálogos por <span style={{fontWeight: 500, color: 'black'}}>Whatsapp</span></p>
                            </div>
                        </section>
                        <div className="rcornersubtitle"><p>Ve a la sección de <Link to="/catalogos">Catálogos</Link> y comparte el que más te guste.</p></div>

                        <br /><br />
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Paso 2: Tus precios"  src={iconstep02} /></div>
                            <div>
                                <h2 className="stepvendora">PASO 2</h2>
                                <p className="stepvendoratitle">Define tus precios</p>
                            </div>
                        </section>
                        <div className="rcornersubtitle"><p>Utiliza el <Link to="/buscador">Buscador</Link> para ver los precios sugeridos, pero recuerda <span style={{fontWeight: 700}}>¡tú decides el precio final!</span></p></div>

                        <br /><br />
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Paso 3: Cierra una venta"  src={iconstep03} /></div>
                            <div>
                                <h2 className="stepvendora">PASO 3</h2>
                                <p className="stepvendoratitle">Cierra <span>tu primera venta</span></p>
                            </div>
                        </section>
                        <div className="rcornersubtitle"><p>Pregúntale a tus clientes qué les gusta, negocia el precio final y acuerda los detalles de tu pago.</p></div>

                        <br /><br />
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Paso 4: Coloca un pedido"  src={iconstep04} /></div>
                            <div>
                                <h2 className="stepvendora">PASO 4</h2>
                                <p className="stepvendoratitle">Coloca <span>un pedido en Vendora</span></p>
                            </div>
                        </section>
                        <div className="rcornersubtitle"><p>Agrega los productos en la sección <Link to="/pedidos">Pedidos</Link>. Recuerda que puedes pagar en el banco, transferencia o pagar en línea.</p></div>

                        <br /><br />
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Paso 5: Recibe"  src={iconstep05} /></div>
                            <div>
                                <h2 className="stepvendora">PASO 5</h2>
                                <p className="stepvendoratitle">Recibe <span>tus productos y</span> Entrega <span>a tus clientes</span></p>
                            </div>
                        </section>
                        <div className="rcornersubtitle"><p>Tu recibes los productos en la comodidad de tu hogar y los entregas a tus clientes.</p></div>
                    </div>
                </Container>
            </div>
            <div>
                <Modal isOpen={openWelcomeModal} toggle={toggleOpenWelcomeModal}>
                    <ModalBody>
                        <ImageGallery
                            autoPlay
                            showPlayButton={false}
                            showFullscreenButton={false}
                            items={images}
                            slideInterval={8000}
                            showNav
                            showBullets={true}
                            showThumbnails={false}
                            onClick={() => {
                                window.analytics.track("Welcome Modal Switched Step")
                            }}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" className="btn btn-primary waves-effect waves-light mb-2 mr-2" onClick={toggleOpenWelcomeModal}>Cerrar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Welcome)